import React from 'react';
import { toErrorMessage } from '../../../api/error/error';
import { DataContainer } from '../../../components/layout/DataContainer';
import { Box, Grid } from '@material-ui/core';
import { useTimeline } from '../../../api/timeline/useTimeline';
import { TimelineEntry } from './TimelineEntry';

export const Timeline = () => {
  const { data: items, isSuccess, isLoading, isError, error } = useTimeline();

  const determineEmptyMessage = () => {
    if (isLoading) return 'Ereignisse werden geladen';
    if (isError) return `Fehler beim Laden.\n${toErrorMessage(error)}`;
    return 'Keine Ereignisse vorhanden.';
  };

  return (
    <DataContainer
      isLoading={isLoading}
      isSuccess={isSuccess}
      isEmpty={!items || items.length === 0}
      emptyMessage={determineEmptyMessage()}
    >
      <Grid container spacing={2} style={{ height: '100%' }}>
        <Grid item xs={12}>
          <Box display="flex" flexDirection="column" style={{ gap: '12px' }}>
            {items?.map((item) => (
              <TimelineEntry key={item.id} item={item} />
            ))}
          </Box>
        </Grid>
      </Grid>
    </DataContainer>
  );
};
